import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { AttachmentKey } from "@/api/models/types";
import LoadingBox from "@/components/LoadingBox.vue";
import CompanyDashboard from "@/components/dashboard/CompanyDashboard.vue";
import StudentDashboard from "@/components/dashboard/StudentDashboard.vue";
import useLoadingState from "@/composables/useLoadingState";
import { calculateMargins } from "@/helpers/calculateMargins";
import { useStore } from "@/store";
import { ActionTypes as ContentActions } from "@/store/modules/content/action-types";
import { ActionTypes as UploadActionTypes } from "@/store/modules/upload/action-types";
import { computed, onMounted, watchEffect } from "vue";
import { setup } from "vue-class-component";
import { useMeta } from "vue-meta";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardOverview',
  setup(__props) {

setup(() =>
  useMeta({
    title: "Dashboard",
  })
);

const store = useStore();

const studentDashboard = computed(() => store.getters["dashboard"]);
const companyDashboard = computed(() => store.getters["companyDashboard"]);
const isStudent = computed(() => store.getters["isStudent"]);
const user = computed(() => store.getters["user"]);

const loadingState = useLoadingState<{ user: boolean; dashboard: boolean }>({
  user: !!user.value,
  dashboard: true,
});

watchEffect(() => {
  if (isStudent.value) {
    loadingState.set("dashboard", !!!studentDashboard.value);
  } else {
    loadingState.set("dashboard", !!!companyDashboard.value);
  }
  loadingState.set("user", !!!user.value);
});

onMounted(async () => {
  await Promise.all([
    store.dispatch(ContentActions.DASHBOARD),
    store.dispatch(UploadActionTypes.UPLOADED_FILES, {
      key: isStudent.value ? AttachmentKey.StudentAvatar : AttachmentKey.CompanyAvatar,
    }),
    store.dispatch(UploadActionTypes.UPLOADED_FILES, {
      key: isStudent.value
        ? AttachmentKey.StudentAvatarFallback
        : AttachmentKey.CompanyAvatarFallback,
    }),
    store.dispatch(UploadActionTypes.UPLOADED_FILES, {
      key: AttachmentKey.CompanyDocuments,
    }),
  ]);
  calculateMargins();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LoadingBox, {
    class: "loading-box",
    "is-loading": _unref(loadingState).isLoading.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (user.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (isStudent.value && studentDashboard.value)
                ? (_openBlock(), _createBlock(StudentDashboard, {
                    key: 0,
                    dashboard: studentDashboard.value,
                    class: "min-h-content-with-fixed-bars"
                  }, null, 8, ["dashboard"]))
                : (companyDashboard.value)
                  ? (_openBlock(), _createBlock(CompanyDashboard, {
                      key: 1,
                      dashboard: companyDashboard.value,
                      class: "min-h-content-with-fixed-bars"
                    }, null, 8, ["dashboard"]))
                  : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})